import React, { useEffect, useState } from "react";
import BreadCrumbComponent from "./Breadcrumb";
import Details from "./Details";
import { useParams } from "react-router-dom";
import "./styles.css";
import axios from "axios";
import {tansformModalData} from "components/ProductDetailsModal/ModalHelpers"
export default function ProductDetails() {
  const { id } = useParams();
  const user = localStorage.getItem("user");
  const [data, setData] = useState(null);
  const [modalData, setModalData] = useState({});
  useEffect(() => {
    if (user) {
      const token = JSON.parse(user).access_token;
      axios
        .get(
          `${process.env.REACT_APP_API_SERVICE}items/productsv2/?id=${id}&token=${token}`
        )
        .then((res) => {
          console.log(res.data);
          const data = tansformModalData(res.data);
          setModalData(data);
          setData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [id, user]);

  return (
    <>
      <BreadCrumbComponent />
      <Details data={data}  modalData={modalData} />
    </>
  );
}
